import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { delay: { type: Number, default: 3000 } }

  buttonTargetConnected() {
    this.clearTimer()
    const isSuccessAlert = this.element.classList.contains('alert-success')
    if (!isSuccessAlert) { return }

    this.timer = setTimeout(() => {
      try { this.buttonTarget.click() } catch (_e) {}
    }, this.delayValue)
  }

  disconnect() {
    this.clearTimer()
  }

  clearTimer() {
    if (this.timer) { clearTimeout(this.timer); this.timer = null }
  }
}
